// Fase 3 · Solo el núcleo de highlight.js + los lenguajes que usa el editor
// (antes `import hljs from 'highlight.js'` metía ~190 lenguajes, 1,35 MB,
// en el bundle inicial de TODA la app). Ya no se importa globalmente: lo
// cargan el editor Quill (módulo `syntax`, que lee `window.hljs`) y Markdown.
import hljs from 'highlight.js/lib/core';
import javascript from 'highlight.js/lib/languages/javascript';
import xml from 'highlight.js/lib/languages/xml';
import css from 'highlight.js/lib/languages/css';
import bash from 'highlight.js/lib/languages/bash';
import shell from 'highlight.js/lib/languages/shell';
import json from 'highlight.js/lib/languages/json';
import 'highlight.js/styles/atom-one-dark.css';

// ----------------------------------------------------------------------

hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('jsx', javascript);
hljs.registerLanguage('xml', xml);
hljs.registerLanguage('html', xml);
hljs.registerLanguage('css', css);
hljs.registerLanguage('bash', bash);
hljs.registerLanguage('sh', shell);
hljs.registerLanguage('json', json);

hljs.configure({
  languages: ['javascript', 'jsx', 'sh', 'html', 'css', 'bash', 'json']
});

if (typeof window !== 'undefined') window.hljs = hljs;

export default hljs;
